import { ServiceTitanCredentialStatus } from "@/business/business";

const businessServiceTitanStatusConfiguration: Record<
  ServiceTitanCredentialStatus,
  {
    description: string;
    modalShowClientAndSecret: boolean;
    modalShowSubmitButton: boolean;
    modalSubtitle: string;
    subtitle: string;
    showClientAndSecret: boolean;
    showSubmitButton: boolean;
  }
> = {
  awaiting_tenant_id: {
    description: "",
    modalShowClientAndSecret: false,
    modalShowSubmitButton: true,
    modalSubtitle: "To set up Service Titan, we first need your Tenant ID.",
    subtitle: "To set up Service Titan, we first need your Tenant ID.",
    showClientAndSecret: false,
    showSubmitButton: true,
  },
  tenant_id_received: {
    description:
      "We have your Tenant ID. We'll notify you when you can take the next step. You can close this window.",
    modalShowClientAndSecret: false,
    modalShowSubmitButton: false,
    modalSubtitle: "Integration pending",
    subtitle: "Integration pending",
    showClientAndSecret: false,
    showSubmitButton: false,
  },
  ready_for_credentials: {
    description: "",
    modalShowClientAndSecret: true,
    modalShowSubmitButton: true,
    modalSubtitle: "Integration pending",
    subtitle: "Integration pending, please add the fields below",
    showClientAndSecret: true,
    showSubmitButton: true,
  },
  credentials_received: {
    description: "",
    modalShowClientAndSecret: true,
    modalShowSubmitButton: true,
    modalSubtitle: "Integration pending",
    subtitle: "Integration pending, please add the fields below",
    showClientAndSecret: true,
    showSubmitButton: false,
  },
  connection_established: {
    description:
      "Your Service Titan integration has been set up successfully! You can close this window.",
    modalShowClientAndSecret: false,
    modalShowSubmitButton: false,
    modalSubtitle: "",
    subtitle: "",
    showClientAndSecret: true,
    showSubmitButton: true,
  },
  business_churned: {
    description: "",
    modalShowClientAndSecret: false,
    modalShowSubmitButton: false,
    modalSubtitle: "",
    subtitle: "",
    showClientAndSecret: false,
    showSubmitButton: false,
  },
};

export default businessServiceTitanStatusConfiguration;
